import { render, staticRenderFns } from "./Create-Bolla.vue?vue&type=template&id=ce28730c&scoped=true&"
import script from "./Create-Bolla.vue?vue&type=script&lang=js&"
export * from "./Create-Bolla.vue?vue&type=script&lang=js&"
import style0 from "./Create-Bolla.vue?vue&type=style&index=0&id=ce28730c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce28730c",
  null
  
)

export default component.exports